import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

export default [
    {
        path: '/tablets',
        component: {
            render: (c) => c('router-view'),
        },
        meta,
        children: [
            {
                path: '',
                name: routeType.TABLETS_CONFIG,
                component: () =>
                    import(
                        /* webpackChunkName: "tablets" */ '@/pages/tablets/List.vue'
                    ),
                meta,
            },
            {
                path: 'auto-login',
                name: routeType.TABLETS_AUTO_LOGIN,
                component: () =>
                    import(
                        /* webpackChunkName: "tablets-auto-login" */ '@/pages/tablets/AutoLoginList.vue'
                    ),
                meta,
            },
        ],
    },
]
